export function isNeedToShowEntityProfileFlatItemIcons() {
  return true
}
